import { useState } from "react";
import { Copy, Check, Code2 } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

export const buildIframe = (query) => `<iframe src="${window.location.origin}/widget?${query}"
  style="position:fixed;bottom:0;right:0;border:0;
  width:440px;height:660px;z-index:99999"
  allowtransparency="true"></iframe>`;

export const copyText = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
  } catch {
    const ta = document.createElement("textarea");
    ta.value = text;
    document.body.appendChild(ta);
    ta.select();
    const ok = document.execCommand("copy");
    ta.remove();
    if (!ok) throw new Error("copy failed");
  }
};

export const EmbedIconButton = ({ testId, onClick, title }) => (
  <button
    type="button"
    data-testid={testId}
    title={title}
    onClick={(e) => { e.stopPropagation(); onClick(); }}
    className="p-1 rounded-md text-slate-400 hover:text-indigo-500 hover:bg-slate-200 dark:hover:bg-slate-700 opacity-0 group-hover:opacity-100 focus:opacity-100 transition-opacity"
  >
    <Code2 className="w-3.5 h-3.5" />
  </button>
);

export default function EmbedCodeDialog({ target, onClose }) {
  const [copied, setCopied] = useState(false);
  const code = target ? buildIframe(target.query) : "";

  const copy = async () => {
    try {
      await copyText(code);
      setCopied(true);
      toast.success("Kode embed disalin");
      setTimeout(() => setCopied(false), 1800);
    } catch {
      toast.error("Gagal menyalin, salin manual");
    }
  };

  return (
    <Dialog open={!!target} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="embed-code-dialog" className="bg-white dark:bg-slate-900 border-slate-200 dark:border-slate-800 text-slate-900 dark:text-white">
        <DialogHeader>
          <DialogTitle data-testid="embed-code-title">Embed: {target?.label}</DialogTitle>
          <DialogDescription>{target?.hint}</DialogDescription>
        </DialogHeader>
        <pre data-testid="embed-code-snippet" className="text-xs bg-slate-950 border border-slate-800 rounded-xl p-3 text-emerald-300 overflow-x-auto whitespace-pre">{code}</pre>
        <button
          data-testid="embed-code-copy"
          onClick={copy}
          className="inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-xl bg-indigo-600 hover:bg-indigo-500 text-white font-semibold text-sm transition-colors"
        >
          {copied ? <Check className="w-4 h-4" /> : <Copy className="w-4 h-4" />}
          {copied ? "Disalin" : "Salin Kode"}
        </button>
      </DialogContent>
    </Dialog>
  );
}
